var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.594 7.28033C18.8869 6.98744 18.8869 6.51256 18.594 6.21967C18.3011 5.92678 17.8263 5.92678 17.5334 6.21967L12.4069 11.3462L7.28033 6.21967C6.98744 5.92678 6.51256 5.92678 6.21967 6.21967C5.92678 6.51256 5.92678 6.98744 6.21967 7.28033L11.3462 12.4069L6.21967 17.5334C5.92678 17.8263 5.92678 18.3011 6.21967 18.594C6.51256 18.8869 6.98744 18.8869 7.28033 18.594L12.4069 13.4675L17.5334 18.594C17.8263 18.8869 18.3011 18.8869 18.594 18.594C18.8869 18.3011 18.8869 17.8263 18.594 17.5334L13.4675 12.4069L18.594 7.28033Z",
    fill: "#50555C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.4b5ea082e6b92138d350878c4a96b422.svg";
export { ForwardRef as ReactComponent };